import common from 'store/modules/common/api'

export const api = {
  get: () => common.httpClient.get(`/api/services/app/ApplicationMenu/Get`, common.options()).then(r => common.processResponse(r)),
}